import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";

import './index.css';
import App from './App';
import Results from './results'
// import Graph from './graph'
import CC2CC from "./cc2cc";

function Index() {
  useEffect(() => {
    document.title = 'Mondonomo Homophones Experiment';

  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/name/:name" element={<Results />} />
        {/*<Route path="/graph/:name" element={<Graph />} />*/}
        <Route path="/countries" element={<CC2CC />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
        <Index />
  </React.StrictMode>
);

reportWebVitals();
